<template>
  <div>
    <div class="hidden pc:block bg-wrapper">
      <div class="flex items-center justify-center bg py-[76px] max-w-[1920px] mx-auto">
        <p class="text-[40px] font-bold text-neutral-950">공지사항</p>
      </div>
    </div>

    <section class="pt-[55px] pb-[70px] pc:py-[140px] pc-con-wrapper1">
      <div class="mb-5 border-t border-b border-solid border-neutral-950 pc:mb-7">
        <p
          class="p-5 text-base font-bold border-b border-solid pc:p-6 bg-neutral-50 border-neutral-200 pc:text-lg text-neutral-950"
        >
          {{ noticeDetail.noticeDetailContent.noticeDetailList.title }}
        </p>
        <div class="flex items-center justify-between p-5 border-b border-solid pc:p-6 border-neutral-200">
          <div class="flex items-center gap-2 pc:gap-3">
            <p class="text-sm pc:text-base text-neutral-500">등록일</p>
            <p class="text-sm pc:text-base text-neutral-500">ㅣ</p>
            <p class="text-sm pc:text-base text-neutral-500">
              {{ noticeDetail.noticeDetailContent.noticeDetailList.createDate }}
            </p>
          </div>
          <div class="flex items-center gap-2 pc:gap-3">
            <p class="text-sm pc:text-base text-neutral-500">조회수</p>
            <p class="text-sm pc:text-base text-neutral-500">ㅣ</p>
            <p class="text-sm pc:text-base text-neutral-500">
              {{ noticeDetail.noticeDetailContent.noticeDetailList.viewCount }}
            </p>
          </div>
        </div>
        <div class="ck-content p-5 text-sm pc:p-6 pc:text-base text-neutral-950">
          <span v-html="noticeDetail.noticeDetailContent.noticeDetailList.content"></span>
        </div>
        <div
          v-if="noticeDetail.attachedFiles.length > 0"
          class="p-5 pc:p-6 border-t border-solid border-neutral-200"
        >
          <p class="mb-2 text-sm font-bold pc:text-base text-neutral-700">첨부파일</p>
          <ul class="flex flex-col gap-1">
            <li
              v-for="(file, index) in noticeDetail.attachedFiles"
              :key="index"
            >
              <a
                :href="file.url"
                :download="file.name"
                class="inline-flex items-center gap-1.5 text-sm pc:text-base text-blue-600 underline cursor-pointer"
                @click.prevent="noticeDetail.downloadFile(file.url, file.name)"
              >
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M4 16v2a2 2 0 002 2h12a2 2 0 002-2v-2M7 10l5 5 5-5M12 15V3" />
                </svg>
                {{ file.name }}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="flex justify-end">
        <p class="px-5 py-2.5 border border-solid border-neutral-500 cursor-pointer" @click="noticeDetail.goBackList">목록</p>
      </div>
    </section>
  </div>
</template>
<script>
import { reactive, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import axios from "@/plugins/axios.js";
import { useStore } from "vuex";

export default {
  components: {},

  setup() {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const idxLeSiteMain = store.getters.getIdxLeSiteMain;

    const noticeDetail = reactive({
      noticeDetailContent: {
        idxNotice: route.query.idxNotice,
        // idxLeSiteMain: route.query.idxLeSiteMain,
        idxLeSiteMain: store.getters.getIdxLeSiteMain,
        noticeDetailList: [],
      },

      attachedFiles: [],

      notice() {
        const idxNotice = noticeDetail.noticeDetailContent.idxNotice;
        // const idxLeSiteMain = route.query.idxLeSiteMain;
        const idxLeSiteMain = store.getters.getIdxLeSiteMain;

        axios.get(`/user/page/notice?idxNotice=${idxNotice}&idxLeSiteMain=${idxLeSiteMain}`).then(function (res) {
          if (res.data.success === true) {
            noticeDetail.noticeDetailContent.noticeDetailList = res.data.data;
            const data = res.data.data;
            const files = [];
            for (let i = 1; i <= 3; i++) {
              if (data[`fileUrl${i}`] && data[`fileName${i}`]) {
                files.push({ url: data[`fileUrl${i}`], name: data[`fileName${i}`] });
              }
            }
            noticeDetail.attachedFiles = files;
          } else {
            alert(res.data.message);
          }
        });
      },

      async downloadFile(url, name) {
        const res = await fetch(url);
        const blob = await res.blob();
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = name;
        link.click();
        URL.revokeObjectURL(link.href);
      },

      goBackList() {
        router.go(-1);
      },
    });

    onMounted(() => {
      // 필수 파라미터(idxNotice) 없이 직접 진입하면 공지 목록으로 보냄 (백엔드 형변환 에러 방지)
      if (!route.query.idxNotice) {
        router.replace({ path: "/learningSupport/noticeList" });
        return;
      }
      noticeDetail.notice();
    });

    return {
      noticeDetail,
      idxLeSiteMain,
    };
  },
};
</script>
<style scoped>
.ck-content {
  display: flow-root;
}
.ck-content :deep(img) {
  max-width: 100%;
  height: auto;
}
</style>
